document.addEventListener("DOMContentLoaded", () => {
	const addCSSclasses = (el, ...cls) => cls.map((cl) => el.classList.add(cl));

	const removeCSSclasses = (el, ...cls) =>
		cls.map((cl) => el.classList.remove(cl));

	// If no-js is on the html tag, replace it
	let noJs = document.querySelector(".no-js");
	if (noJs) {
		addCSSclasses(noJs, "js");
		removeCSSclasses(noJs, "no-js");
	}

	// if (AOS) {
	// 	AOS.init();
	// }

	// ? end of search modal

	//! footer accordion
	const footerMenuToggles = document.querySelectorAll(".footer-menu-toggle");

	if (footerMenuToggles) {
		footerMenuToggles.forEach((toggle) => {
			toggle.addEventListener("click", (e) => {
				e.stopPropagation();
				if (toggle.dataset.isopen === "false") {
					toggle.dataset.isopen = "true";
				} else {
					toggle.dataset.isopen = "false";
				}
			});
		});
	}

	//! nav accordion
	const navToggles = document.querySelectorAll(
		".mobile-menu__item.has-mega-menu .mobile-menu__link"
	);

	if (navToggles) {
		navToggles.forEach((toggle) => {
			toggle.addEventListener("click", (e) => {
				e.stopPropagation();
				let parentMenuItem = toggle.closest(
					".mobile-menu__item.has-mega-menu"
				);

				if (parentMenuItem) {
					// Toggle the data-isopen attribute on the parent
					if (parentMenuItem.dataset.isopen === "false") {
						parentMenuItem.dataset.isopen = "true";
					} else {
						parentMenuItem.dataset.isopen = "false";
					}
				}
			});
		});
	}

	//? mobile menu
	const mobileMenu = document.querySelector(".mobile-menu");

	const burgerBtn = document.getElementById("burger");
	const burgerIcon = document.getElementById("burgerIcon");

	function toggleMobileNav(e) {
		e.preventDefault();
		if (mobileMenu.classList.contains("hidden")) {
			openMobileNav();
		} else {
			closeMobileNav();
		}
	}

	function closeMobileNav() {
		// e.preventDefault();
		mobileMenu.classList.add("hidden");
		document.body.style.overflow = "auto";
		burgerIcon.classList.remove("open");
	}
	function openMobileNav() {
		// e.preventDefault();
		mobileMenu.classList.remove("hidden");
		document.body.style.overflow = "hidden";
		burgerIcon.classList.add("open");
	}

	if (burgerBtn) {
		burgerBtn.addEventListener("click", (e) => {
			toggleMobileNav(e);
		});
	}

	var filterHeading = document.querySelector(".filter-controls__heading");
	var filterControls = document.getElementById("filterControls");

	if (filterHeading) {
		filterHeading.addEventListener("click", function () {
			filterControls.classList.toggle("expanded");
		});
	}

	addHighlightEffect();

	// window.addEventListener("scroll", function () {
	// 	// Selectors
	// 	var body = document.body,
	// 		panels = document.querySelectorAll(".panel");

	// 	// Change 33% earlier than scroll position so color is there when you arrive.
	// 	var scroll = window.scrollY + window.innerHeight / 3;

	// 	panels.forEach(function (panel) {
	// 		var panelTop = panel.offsetTop,
	// 			panelHeight = panel.offsetHeight;

	// 		// if position is within range of this panel.
	// 		if (panelTop <= scroll && panelTop + panelHeight > scroll) {
	// 			// Remove all classes on body with color-
	// 			body.className = body.className.replace(/\bcolor-\S+/g, "");

	// 			// Check for specific classes on the panel and add corresponding class to the body
	// 			if (
	// 				panel.classList.contains(
	// 					"has-organic-cotton-background-color"
	// 				)
	// 			) {
	// 				body.classList.add("has-organic-cotton-background-color");
	// 			} else if (
	// 				panel.classList.contains("has-opal-background-color")
	// 			) {
	// 				body.classList.add("has-opal-background-color");
	// 			}
	// 			// Add more else-if statements here for other background colors
	// 		}
	// 	});
	// });

	// Trigger the scroll event on page load
	// window.dispatchEvent(new Event("scroll"));

	// Code above this comment
});

function addHighlightEffect() {
	const buttons = document.querySelectorAll(
		".wp-block-f0-blocks-f0-button.f0-button.is-style-pill"
	);

	// If no buttons are found, exit the function
	if (buttons.length === 0) {
		return;
	}

	let lastHighlightedIndex = -1;

	function highlightRandomButton() {
		if (lastHighlightedIndex !== -1) {
			// Remove the highlight from the last button
			buttons[lastHighlightedIndex].classList.remove("pill-highlight");
		}

		let randomIndex;
		do {
			randomIndex = Math.floor(Math.random() * buttons.length);
		} while (randomIndex === lastHighlightedIndex); // Ensure a different button is chosen

		buttons[randomIndex].classList.add("pill-highlight");
		lastHighlightedIndex = randomIndex;

		// Remove the class after 800 milliseconds
		setTimeout(() => {
			buttons[randomIndex].classList.remove("pill-highlight");
		}, 150);
	}

	setInterval(highlightRandomButton, 2500); // Run every 2.8 seconds (800 ms highlight + 2 seconds pause)
}
